<template lang="pug">
  .newcomer-guide(v-if="guideModuleData.moduleKey")
    TemplateExchange(
      :moduleData="guideModuleData"
      :points="points"
      @refreshGuide="handleRefreshGuide"
      @bounty="$emit('bounty')"
      @expired="$emit('expired')"
    )
    //- TemplateDeduct(
    //-   v-else-if="templateType === 3"
    //-   :moduleData="guideModuleData"
    //-   :points="points"
    //-   @bounty="$emit('bounty')"
    //-   @expired="$emit('expired')"
    //- )
</template>

<script>
import eventBus from '@/const/eventBus';
import { getTaskListData } from '../../../common/task';
import TemplateExchange from './template-exchange';
// import TemplateDeduct from './template-deduct';

export default {
  name: 'NewcomerGuide',
  components: {
    TemplateExchange,
    // TemplateDeduct,
  },
  props: {
    moduleKey: {
      type: String,
      default: '',
    },
    points: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      guideModuleData: {},
    };
  },
  computed: {
    templateType() {
      return (this.guideModuleData.newComerGuideDTO || {}).templateType;
    },
  },
  created() {
    this.fetchGuideData();
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    eventBus.$on('refreshNewcomerGuide', this.fetchGuideData);
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    eventBus.$off('refreshNewcomerGuide', this.fetchGuideData);
  },
  methods: {
    async fetchGuideData() {
      const { success, data } = await getTaskListData({
        newTaskScene: true,
        newWelfare: true,
      });
      if (!success) return;

      const { taskGroupInfoDTOS = [] } = data || {};
      const guideGroup = taskGroupInfoDTOS.find(
        (g) => g.moduleKey === (this.moduleKey || 'welfare_newcomer_guide'),
      );
      if (!guideGroup) return;

      this.guideModuleData = guideGroup;
    },
    // 领奖/任务完成后：刷新新人引导数据
    async handleRefreshGuide() {
      this.fetchGuideData();
    },
    // 页面重新可见时刷新（用户完成任务后返回）
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.fetchGuideData();
      }
    },
  },
};
</script>
